const unquote = (value: string): string => value.replace(/^"(.*)"$/, '$1');

/**
 * Extracts the file name from a `Content-Disposition` header value.
 * Prefers the RFC 5987 extended form (`filename*=UTF-8''…`) which can carry
 * non-ASCII names, falling back to the plain `filename=` token.
 */
export const getContentDispositionFilename = (contentDisposition: string | null | undefined): string | null => {
  if (!contentDisposition) {
    return null;
  }

  const extended = /filename\*=(?:[^']*'[^']*')?([^;]+)/i.exec(contentDisposition);
  if (extended?.[1]) {
    try {
      return decodeURIComponent(unquote(extended[1].trim()));
    } catch {
      return unquote(extended[1].trim());
    }
  }

  const standard = /filename=([^;]+)/i.exec(contentDisposition);
  if (standard?.[1]) {
    return unquote(standard[1].trim());
  }

  return null;
};
